export default {
  discount_types: {
    cashback: 'Spaarpunten',
    promo_code: 'Promotiecode',
  },
  input: {
    label: '{{cashbackLabel}} of {{promoCodeLabel}}',
    placeholder: 'Promotiecode',
  },
  buttons: {
    apply: 'Toepassen',
    remove: 'Verwijderen',
  },
  feedback: {
    login:
      '<highlight>Log in</highlight> om deze promotie te gebruiken, zodat we kunnen controleren of je hem nog niet hebt gebruikt. Log in en probeer het opnieuw.',
    usage_threshold: 'Minimaal bestelbedrag voor deze promotie is (excl. bezorgkosten)',
    promo_code_added: 'Promotiecode succesvol toegepast',
  },
};
